module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-check-fill-94f77eae.svg";